import { apiClient } from '@app/api';
import { useAuditReportsGetGipMetadataCampaigns } from '@mi-front/api-v2';
import { DateTimeStr } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { useGipFormNewApi } from './useGipFormNewApi';

/**
 * Campaigns list for the GIP form, scoped by stations, dates, and advertisers.
 * Switches between legacy logger and audit-reports APIs via `app__gip_form_new_api`.
 */
export function useGipCampaignsQuery(
  params: {
    from: DateTimeStr;
    to: DateTimeStr;
    stations: string[];
    advertisers: string[];
  },
  enabled: boolean,
) {
  const useNewApi = useGipFormNewApi();

  const legacy = useQuery({
    queryKey: ['gip-report-campaigns', params],
    queryFn: () =>
      apiClient.audit.gipFetchCampaigns(params).then((values) => values.filter((v) => !!v)),
    enabled: !useNewApi && enabled,
  });

  const neu = useAuditReportsGetGipMetadataCampaigns(params, {
    query: {
      enabled: useNewApi && enabled,
      select: (campaigns) => campaigns.filter((v) => !!v),
    },
  });

  return useNewApi ? neu : legacy;
}
